export const isAbsoluteUrl = (url) => url.toLowerCase().startsWith('http');
